import React from 'react';
import { Helmet } from 'react-helmet';
import {
  Datagrid,
  Filter,
  List,
  TextField,
  DateField,
  ReferenceField,
  SelectInput,
  FunctionField,
} from 'react-admin';
import StatusField from '../../components/StatusField';
import { status } from './const';

const IncidentFilter = (props: any) => (
  <Filter {...props}>
    <SelectInput label="Status" source="status" choices={status} resettable />
  </Filter>
);

const AlertList = (props: any) => (
  <List
    exporter={false}
    filters={<IncidentFilter />}
    bulkActionButtons={false}
    {...props}>
    <Datagrid rowClick="show">
      <TextField label="ID" source="id" />
      <ReferenceField
        label="Incident ID"
        source="incidentId"
        reference="incidents"
        link={(record, reference) => `/${reference}/${record.id}/show`}>
        <TextField source="id" emptyText="-" />
      </ReferenceField>
      <ReferenceField
        label="Customer"
        source="customerId"
        reference="customers"
        link={(record, reference) => `/${reference}/${record.id}/show`}
        emptyText="-">
        <ReferenceField
          source="adminUserId"
          reference="users"
          link={record => `/customers/${record.id}/show`}>
          <FunctionField
            render={(record: any) =>
              `${record.firstName ?? ''} ${record.lastName ?? ''}`
            }
          />
        </ReferenceField>
      </ReferenceField>
      <TextField label="Medium" source="medium" emptyText="-" />
      <TextField label="Recipient" source="recipient" emptyText="-" />
      <DateField label="Created At" source="createdAt" showTime />
      <StatusField source="status" />
    </Datagrid>
  </List>
);

export default AlertList;
